import { axiosAPI as axios, responseHandler } from 'utils';
import { isOnline } from 'mobile-modules/offline';
import { cacheFamilySession, getCachedFamilySession } from 'mobile-modules/offline/cache';

const getErrorMessage = (result, fallback) => (
  result?.error?.message
  || result?.error
  || result?.message
  || fallback
);

const familySessionRequest = async (request, fallbackMessage) => {
  // Do not pass Family/Friends mutations through the generic responseHandler.
  // That helper converts failed HTTP requests into ordinary values, which made
  // the Save flow ambiguous. Axios errors must reject so the dialog can show
  // the real backend failure and never report a false successful save.
  const response = await request;
  const result = response?.data;

  if (!result || result.success === false || result.error || !Array.isArray(result.members)) {
    throw new Error(getErrorMessage(result, fallbackMessage));
  }

  return result;
};

export const getRegistrationOptions = (params = {}) => (
  responseHandler(axios.get('api/mobile-wrapper/registration-options', { params }))
);

export const getFamilySession = async familyAccountToken => {
  if (!isOnline()) {
    const cached = await getCachedFamilySession();
    if (cached) return cached;
    throw new Error('Family & Friends have not been downloaded for offline use yet.');
  }
  const result = await familySessionRequest(
    axios.post('api/mobile-wrapper/family-session', { familyAccountToken }),
    'Unable to load Family & Friends.',
  );
  await cacheFamilySession(result);
  return result;
};

export const addFamilyFriend = (familyAccountToken, firstname) => (
  familySessionRequest(
    axios.post('api/mobile-wrapper/family-friends', {
      familyAccountToken,
      firstname,
    }),
    'Unable to add Family or Friend.',
  )
);

export const removeFamilyFriend = (familyAccountToken, memberId) => (
  familySessionRequest(
    axios.delete(`api/mobile-wrapper/family-friends/${memberId}`, {
      data: { familyAccountToken },
    }),
    'Unable to remove Family or Friend.',
  )
);
